import React from 'react';

export const sectionStyle: React.CSSProperties = {
  background: 'linear-gradient(135deg, #f0f7ff 0%, #f8fbff 100%)',
  borderRadius: 10,
  border: '1px solid #d4e4f7',
  padding: '16px',
  marginBottom: 16,
};

export const iconWrapperStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 28,
  height: 28,
  borderRadius: 6,
  background: '#2CBDFF',
  color: '#fff',
  fontSize: 14,
};

export const segmentedTheme = {
  components: { Segmented: { itemSelectedBg: '#2CBDFF', itemSelectedColor: '#fff', trackBg: '#f0f0f0' } },
};

export const labelStyle: React.CSSProperties = {
  fontSize: 11,
  fontWeight: 600,
  color: '#8c8c8c',
  textTransform: 'uppercase',
  letterSpacing: 0.3,
  marginBottom: 2,
  display: 'block',
};

export const serviceGridColumns = '1fr 130px 70px 65px 80px 70px 70px 90px 90px 100px 32px';

/**
 * Selected entry inside a multi-select (services, templates). Primary tint rather than a full
 * strength colour tag - readable on white and calm enough to repeat a dozen times in one field.
 * Shared so the pickers cannot drift apart.
 */
export const selectedTagStyle: React.CSSProperties = {
  padding: '2px 8px',
  background: '#eaf7ff',
  border: '1px solid #b3e6ff',
  borderRadius: 6,
  fontSize: 13,
  fontWeight: 500,
  color: '#0b7cad',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
};
